import React from 'react';
import { Link } from 'react-router-dom';

/** Sticky sign-up bar for phones on the public pages — the primary action stays
 *  reachable with a thumb no matter how far down the page someone has scrolled. */
export const MobileCtaBar = ({ label = 'Start free — 5 analyses included' }) => (
  <div
    className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/95 px-4 pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-3 backdrop-blur-md sm:hidden"
    data-testid="mobile-cta-bar"
  >
    <div className="flex items-center gap-3">
      <Link
        to="/register"
        className="flex h-12 flex-1 items-center justify-center rounded-lg bg-slate-900 px-4 text-sm font-semibold text-white transition-colors active:bg-slate-800"
        data-testid="mobile-cta-register"
      >
        {label}
      </Link>
      <Link
        to="/login"
        className="flex h-12 items-center justify-center rounded-lg border border-slate-300 px-4 text-sm font-medium text-slate-700"
        data-testid="mobile-cta-login"
      >
        Sign in
      </Link>
    </div>
  </div>
);

export default MobileCtaBar;
